// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sidebar_sidebar__1JO1i {
  display: flex;
  flex: 1 1;
  height: 100%;
  min-width: 15%;
  max-width: 15%;
  position: sticky;
  /* top: 50px; */
  margin-top: 25px; 
  flex-direction: column;
  gap: 2rem;
  
}

.sidebar_sidebarWrapper__P0pYH {
  color: var(--hsrcDarkBlue);
  font-size: 16px;
}

.sidebar_sidebarMenu__RQVln {
  
  padding: 2rem;
}

.sidebar_sidebarTitle__YaupM {
  font-size: 13px;
  color: rgb(187, 186, 186);
}

.sidebar_sidebarList__cCHmc {
  list-style: none;
  padding: 5px;
   color: var(--hsrcDarkBlue);
  font-size: 16px;
  font-family: var(--FontFamily);
}

.sidebar_sidebarSubList__TQLc5 {
  list-style: none;
  padding: 5px;
  color: var(--hsrcDarkBlue);
  font-size: 16px;
  font-family: var(--FontFamily);
}

.sidebar_sidebarListItem__ixS26 {
  padding: 5px;
  cursor: pointer;
  display: flex;
  flex-direction: column;

flex-shrink: 0; 
 align-items: center;
  border-radius: 10px;
  margin-bottom: 25px; 
}

.sidebar_sidebarListItem__ixS26.sidebar_active__YXawJ,
.sidebar_sidebarListItem__ixS26:hover {
  background-color: rgb(240, 240, 255);
}

.sidebar_sidebarSubListItem__snvHg {
  padding-left: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 10px;
  margin-bottom: 25px;
}

.sidebar_sidebarSubListItem__snvHg.sidebar_active__YXawJ,
.sidebar_sidebarSubListItem__snvHg:hover {
  background-color: rgb(240, 240, 255);
}

.sidebar_sidebarIcon__5FLKA{
    margin-right: 5px;
    font-size: 20px !important;
}

.sidebar_sidebarIconParent__VvZUC{
    margin-right: 5px;
    font-size: 20px !important;
}

.sidebar_sidebarSubListItem__snvHg.sidebar_active__YXawJ,
.sidebar_sidebarSubListItem__snvHg:hover {
  background-color: rgb(240, 240, 255);
}

.sidebar_sidebarSubIcon__Z1Vln {
  margin-right: 5px;
  font-size: 16px !important;
}

.sidebar_pageHint__HFNia {
  font-family: var(--bookFontFamily);
  font-size: 16px;
  white-space: pre-wrap;
}

.sidebar_pageHint__HFNia .sidebar_tooltiptext__20Dql {
  visibility: hidden;
  width: 55%;
  font-size: 12px;
  background-color: var(--hsrcLightRed);
  color: var(--hsrcMainRed);
  text-align:center;
  margin-left: 20px;
  padding: 10px;
  border: 1px solid var(--hsrcMainRed);
  box-sizing: border-box;
  border-radius: 5px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;

}


/* Show the tooltip text when you mouse over the tooltip container */

.sidebar_pageHint__HFNia:hover .sidebar_tooltiptext__20Dql {
  visibility: visible;
}

.sidebar_hsrc__logo__5sWop {
  display: flex;
  align-self: flex-start;
 width: auto;
  height: 90px;

  }

.sidebar_logo__s8TI3 {
  display: flex;
  /* vertical-align: bottom; */
 
  width: 160px;
  height: 60px;
  margin-left:  3rem;
  margin-bottom: 3rem;
 }

 .sidebar_logout__BRCSp {
  display: inline-block;
  border-radius: 50px;
  background-color: var(--hsrcOrange);
  border-color: var(--hsrcOrange);
  border-style: solid;
  border-width: 1rem;
  color: var(--hsrcWhite);
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  padding-left: 15px;
  padding-right: 15px;
  transition: all 0.5s;
  /* margin: 15px; */
  letter-spacing: 0.15rem;
  cursor: pointer;
  height: 30px;
  width: auto;
}

.sidebar_avatar__Mj12d{
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;

  margin-left:  3rem;
  margin-bottom: 1rem;
  margin-top: 1rem;
  border-radius: 15px;
  background-color: var(--hsrcDarkYellow);
  border-color: var(--hsrcDarkYellow);
  border-style: solid;
  border-width: 0.1rem;
  color: var(--hsrcDarkBlue);
  padding: 0.8rem;
  /* text-align: center; */
}`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/components/Sidebar/sidebar.module.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,SAAO;EACP,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;;AAEX;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;GACX,0BAA0B;EAC3B,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;;AAExB,cAAc;CACb,mBAAmB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,qCAAqC;EACrC,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;;EAElB,oDAAoD;EACpD,kBAAkB;EAClB,UAAU;;AAEZ;;;AAGA,oEAAoE;;AAEpE;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;CACvB,WAAW;EACV,YAAY;;EAEZ;;AAEF;EACE,aAAa;EACb,4BAA4B;;EAE5B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;;EAEnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,mCAAmC;EACnC,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;EACf,wBAAwB;AAC1B","sourcesContent":["\r\n.sidebar {\r\n  display: flex;\r\n  flex: 1;\r\n  height: 100%;\r\n  min-width: 15%;\r\n  max-width: 15%;\r\n  position: sticky;\r\n  /* top: 50px; */\r\n  margin-top: 25px; \r\n  flex-direction: column;\r\n  gap: 2rem;\r\n  \r\n}\r\n\r\n.sidebarWrapper {\r\n  color: var(--hsrcDarkBlue);\r\n  font-size: 16px;\r\n}\r\n\r\n.sidebarMenu {\r\n  \r\n  padding: 2rem;\r\n}\r\n\r\n.sidebarTitle {\r\n  font-size: 13px;\r\n  color: rgb(187, 186, 186);\r\n}\r\n\r\n.sidebarList {\r\n  list-style: none;\r\n  padding: 5px;\r\n   color: var(--hsrcDarkBlue);\r\n  font-size: 16px;\r\n  font-family: var(--FontFamily);\r\n}\r\n\r\n.sidebarSubList {\r\n  list-style: none;\r\n  padding: 5px;\r\n  color: var(--hsrcDarkBlue);\r\n  font-size: 16px;\r\n  font-family: var(--FontFamily);\r\n}\r\n\r\n.sidebarListItem {\r\n  padding: 5px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\nflex-shrink: 0; \r\n align-items: center;\r\n  border-radius: 10px;\r\n  margin-bottom: 25px; \r\n}\r\n\r\n.sidebarListItem.active,\r\n.sidebarListItem:hover {\r\n  background-color: rgb(240, 240, 255);\r\n}\r\n\r\n.sidebarSubListItem {\r\n  padding-left: 10px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 10px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.sidebarSubListItem.active,\r\n.sidebarSubListItem:hover {\r\n  background-color: rgb(240, 240, 255);\r\n}\r\n\r\n.sidebarIcon{\r\n    margin-right: 5px;\r\n    font-size: 20px !important;\r\n}\r\n\r\n.sidebarIconParent{\r\n    margin-right: 5px;\r\n    font-size: 20px !important;\r\n}\r\n\r\n.sidebarSubListItem.active,\r\n.sidebarSubListItem:hover {\r\n  background-color: rgb(240, 240, 255);\r\n}\r\n\r\n.sidebarSubIcon {\r\n  margin-right: 5px;\r\n  font-size: 16px !important;\r\n}\r\n\r\n.pageHint {\r\n  font-family: var(--bookFontFamily);\r\n  font-size: 16px;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.pageHint .tooltiptext {\r\n  visibility: hidden;\r\n  width: 55%;\r\n  font-size: 12px;\r\n  background-color: var(--hsrcLightRed);\r\n  color: var(--hsrcMainRed);\r\n  text-align:center;\r\n  margin-left: 20px;\r\n  padding: 10px;\r\n  border: 1px solid var(--hsrcMainRed);\r\n  box-sizing: border-box;\r\n  border-radius: 5px;\r\n\r\n  /* Position the tooltip text - see examples below! */\r\n  position: absolute;\r\n  z-index: 1;\r\n\r\n}\r\n\r\n\r\n/* Show the tooltip text when you mouse over the tooltip container */\r\n\r\n.pageHint:hover .tooltiptext {\r\n  visibility: visible;\r\n}\r\n\r\n.hsrc__logo {\r\n  display: flex;\r\n  align-self: flex-start;\r\n width: auto;\r\n  height: 90px;\r\n\r\n  }\r\n\r\n.logo {\r\n  display: flex;\r\n  /* vertical-align: bottom; */\r\n \r\n  width: 160px;\r\n  height: 60px;\r\n  margin-left:  3rem;\r\n  margin-bottom: 3rem;\r\n }\r\n\r\n .logout {\r\n  display: inline-block;\r\n  border-radius: 50px;\r\n  background-color: var(--hsrcOrange);\r\n  border-color: var(--hsrcOrange);\r\n  border-style: solid;\r\n  border-width: 1rem;\r\n  color: var(--hsrcWhite);\r\n  text-align: center;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n  transition: all 0.5s;\r\n  /* margin: 15px; */\r\n  letter-spacing: 0.15rem;\r\n  cursor: pointer;\r\n  height: 30px;\r\n  width: auto;\r\n}\r\n\r\n.avatar{\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-content: center;\r\n  align-items: center;\r\n\r\n  margin-left:  3rem;\r\n  margin-bottom: 1rem;\r\n  margin-top: 1rem;\r\n  border-radius: 15px;\r\n  background-color: var(--hsrcDarkYellow);\r\n  border-color: var(--hsrcDarkYellow);\r\n  border-style: solid;\r\n  border-width: 0.1rem;\r\n  color: var(--hsrcDarkBlue);\r\n  padding: 0.8rem;\r\n  /* text-align: center; */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `sidebar_sidebar__1JO1i`,
	"sidebarWrapper": `sidebar_sidebarWrapper__P0pYH`,
	"sidebarMenu": `sidebar_sidebarMenu__RQVln`,
	"sidebarTitle": `sidebar_sidebarTitle__YaupM`,
	"sidebarList": `sidebar_sidebarList__cCHmc`,
	"sidebarSubList": `sidebar_sidebarSubList__TQLc5`,
	"sidebarListItem": `sidebar_sidebarListItem__ixS26`,
	"active": `sidebar_active__YXawJ`,
	"sidebarSubListItem": `sidebar_sidebarSubListItem__snvHg`,
	"sidebarIcon": `sidebar_sidebarIcon__5FLKA`,
	"sidebarIconParent": `sidebar_sidebarIconParent__VvZUC`,
	"sidebarSubIcon": `sidebar_sidebarSubIcon__Z1Vln`,
	"pageHint": `sidebar_pageHint__HFNia`,
	"tooltiptext": `sidebar_tooltiptext__20Dql`,
	"hsrc__logo": `sidebar_hsrc__logo__5sWop`,
	"logo": `sidebar_logo__s8TI3`,
	"logout": `sidebar_logout__BRCSp`,
	"avatar": `sidebar_avatar__Mj12d`
};
export default ___CSS_LOADER_EXPORT___;
